<template>
    <div>
        <CRow class="content-fade-in">
            <CCol md="12">
                <CCard>
                    <CCardBody>
                        <CForm class="form-basic">
                            <CRow>
                                <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                                    <CRow>
                                        <CCol xs="12" sm="12" md="2" lg="2" xl="2" v-if="imgUrl">
                                            <img class="thumbnail" :src="imgUrl" @click="chooseFile()" />
                                        </CCol>
                                        <CCol xs="12" sm="12" md="2" lg="2" xl="2" v-else>
                                            <img class="thumbnail" @click="chooseFile()" />
                                            <div class="valid-error"
                                                v-show="!(selectedFiles.data.validator ? selectedFiles.data.validator.isValid : true)">
                                                {{ selectedFiles.data.validator ?
                                                    selectedFiles.data.validator.errorMessage : "" }}
                                            </div>
                                        </CCol>
                                        <CCol sm="12" md="12" xl="12" v-show="false">
                                            <div class="form-input-wrapper">
                                                <div class="form-group">
                                                    <label class="form-label" for="uploadFile">Chọn ảnh<span
                                                            class='required'> *</span></label>
                                                    <div class="custom-file"
                                                        :class="selectedFiles.data.validator.isValid == false ? 'input-valid-error' : ''">
                                                        <input type="file" class="custom-file-input" id="uploadFile"
                                                            ref="file" accept=".jpg, .jpeg, .png, .gif"
                                                            @change="selectFile($event)">
                                                        <label class="custom-file-label" for="uploadFile">{{ fileName
                                                        }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </CCol>
                                        <CCol xs="12" sm="12" md="10" lg="10" xl="10">
                                            <BaseInput :options="codeInput.options" :data="codeInput.data" />
                                            <div class="form-group">
                                                <label class="form-label">Theo lô/serial</label>
                                                <CInputCheckbox custom :checked="isByLotSerialCheckBox.data.model" class="ml-2"
                                                    @update:checked="changeIsByLotSerial($event)" addInputClasses="override-custom">
                                                </CInputCheckbox>
                                            </div>
                                        </CCol>
                                        <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                                            <BaseInput :options="nameInput.options" :data="nameInput.data" />
                                        </CCol>
                                        <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                                            <BaseSelect :options="cateSelect.options" :data="cateSelect.data" ref="cateSelect"></BaseSelect>
                                        </CCol>
                                        <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                                            <BaseSelect :options="uomSelect.options" :data="uomSelect.data" ref="uomSelect"></BaseSelect>
                                        </CCol>
                                        <CCol sm="12" md="12" xl="12">
                                            <BaseTextArea :options="descriptionInput.options" :data="descriptionInput.data"
                                                v-model="descriptionInput.data.model" />
                                        </CCol>
                                    </CRow>
                                </CCol>
                            </CRow>
                            <div slot="footer" class="footer-form mt-4">
                                <CButton color="secondary" class="btn-action-primary mr-2" @click="$router.go(-1)"><i
                                        class="fa fa-reply"></i>
                                    Hủy bỏ
                                </CButton>
                                <CButton color="primary" class="btn-action-primary" @click="submitData()">
                                    <i class="fa fa-save"></i> Lưu lại
                                </CButton>
                            </div>
                            <BaseLoading :loading="loading.value"></BaseLoading>
                        </CForm>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>
  
<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";
import BaseTextArea from "../base/BaseTextArea";

export default {
    name: "ProductAdd",
    components: { BaseSelect, BaseInput, BaseLoading, BaseTextArea },
    notifications: {
        showSuccessMsg: {
            type: "success",
            title: "Success"
        },
        showErrorMsg: {
            type: "error",
            title: "Errors"
        },
        showWarningMsg: {
            type: "warn",
            title: "warn"
        }
    },
    data: function () {
        let that = this;
        return {
            loading: { value: false },
            fileName: "",
            imgUrl: "",
            isByLotSerialCheckBox: {
                options: {
                    label: "Theo Lô/Serial"
                },
                data: {
                    name: "isByLotSerial",
                    model: false,
                    updateCallback: function () {
                        that.submitData();
                    },
                }
            },
            codeInput: {
                options: {
                    label: "Mã sản phẩm <span class='required'>*</span>",
                    placeholder: "Mã sản phẩm",
                    maxlength: 64
                },
                data: {
                    name: "code",
                    model: "",
                    updateCallback: function () {
                        that.submitData();
                    },
                    validator: {
                        isValid: true,
                        errorMessage: "",
                        valid: function () {
                            let value = that.codeInput.data.model;
                            if (value === "") {
                                this.isValid = false;
                                this.errorMessage = "Mã sản phẩm không được để trống";
                            } else if (value.length > 64) {
                                this.isValid = false;
                                this.errorMessage = "Mã sản phẩm không được quá 128 kí tự";
                            } else {
                                this.isValid = true;
                            }
                            return this.isValid;
                        }
                    }
                }
            },
            nameInput: {
                options: {
                    label: "Tên sản phẩm <span class='required'>*</span>",
                    placeholder: "Tên sản phẩm",
                    maxlength: 256
                },
                data: {
                    name: "name",
                    model: "",
                    updateCallback: function () {
                        that.submitData();
                    },
                    validator: {
                        isValid: true,
                        errorMessage: "",
                        valid: function () {
                            let value = that.nameInput.data.model;
                            if (value === "") {
                                this.isValid = false;
                                this.errorMessage = "Tên sản phẩm không được để trống";
                            } else if (value.length > 256) {
                                this.isValid = false;
                                this.errorMessage = "Tên sản phẩm không được quá 128 kí tự";
                            } else {
                                this.isValid = true;
                            }
                            return this.isValid;
                        }
                    }
                }
            },
            descriptionInput: {
                options: {
                    label: "Mô tả",
                    placeholder: "Mô tả",
                    maxlength: 512,
                    rows: 5
                },
                data: {
                    name: "description",
                    model: "",
                    updateCallback: function () {
                        that.submitData();
                    },
                    validator: {
                        isValid: true,
                        errorMessage: "",
                        valid: function () {
                            // let value = that.descriptionInput.data.model;
                            // if (value === "" || value.trim() === "") {
                            //     this.isValid = false;
                            //     this.errorMessage = "Mô tả bản tin không được để trống";
                            // } else {
                            //     this.isValid = true;
                            // }
                            return this.isValid;
                        }
                    }
                }
            },
            selectedFiles: {
                data: {
                    name: "file",
                    model: {
                        fileName: '',
                        content: '',
                        size: '',
                        type: ''
                    },
                    validator: {
                        isValid: true,
                        errorMessage: "",
                        valid: function () {
                            let value = that.selectedFiles.data.model.fileName;
                            if (value.length == 0) {
                                this.isValid = false;
                                this.errorMessage = "Tệp tin không được để trống";
                            } else {
                                let type = that.selectedFiles.data.model.type;
                                if (type == "image/jpeg" || type == "image/png" || type == "image/gif") {
                                    this.isValid = true;
                                    this.errorMessage = "";
                                } else {
                                    this.isValid = false;
                                    this.errorMessage = "Sai định dạng tệp tin";
                                }
                            }
                            return this.isValid;
                        }
                    }
                }
            },
            cateSelect: {
                options: {
                    filter: true,
                    label: "Danh mục <span class='required'>*</span>",
                    selectAllText: "Chọn danh mục",
                    'keyField': 'value',
                    'valueField': 'text',
                },
                data: {
                    name: "categoryId",
                    items: [],
                    model: "",
                    source: {
                        url: '/category/list-category',
                        dataSubmit: function () {
                            return {}
                        },
                        response: function (dataResponse) {
                            that.cateSelect.data.items = dataResponse.data;
                        }
                    },
                    validator: {
                        isValid: true,
                        errorMessage: "",
                        valid: function () {
                            let value = that.cateSelect.data.model;
                            if (!value || value === "") {
                                this.isValid = false;
                                this.errorMessage = "Danh mục không được để trống";
                            } else {
                                this.isValid = true;
                                this.errorMessage = "";
                            }
                            return this.isValid;
                        }
                    },
                }
            },
            uomSelect: {
                options: {
                    filter: true,
                    label: "Đơn vị tính <span class='required'>*</span>",
                    selectAllText: "Chọn đơn vị tính",
                    'keyField': 'value',
                    'valueField': 'text',
                },
                data: {
                    name: "uomId",
                    items: [],
                    model: "",
                    source: {
                        url: '/uom/list-uom',
                        dataSubmit: function () {
                            return {}
                        },
                        response: function (dataResponse) {
                            that.uomSelect.data.items = dataResponse.data;
                        }
                    },
                    validator: {
                        isValid: true,
                        errorMessage: "",
                        valid: function () {
                            let value = that.uomSelect.data.model;
                            if (!value || value === "") {
                                this.isValid = false;
                                this.errorMessage = "Đơn vị tính không được để trống";
                            } else {
                                this.isValid = true;
                                this.errorMessage = "";
                            }
                            return this.isValid;
                        }
                    },
                }
            },
        }
    },
    methods: {
        changeIsByLotSerial(event) {
            this.isByLotSerialCheckBox.data.model = event;
        },
        submitData: function () {
            let that = this;
            let isValid = true;
            isValid &= this.codeInput.data.validator.valid();
            isValid &= this.nameInput.data.validator.valid();
            isValid &= this.selectedFiles.data.validator.valid();
            isValid &= this.cateSelect.data.validator.valid();
            isValid &= this.uomSelect.data.validator.valid();
            if (!isValid) {
                return;
            }
            // let dataRequest = {
            //     code: this.codeInput.data.model,
            //     name: this.nameInput.data.model,
            //     description: this.descriptionInput.data.model
            // }
            this.$helper.loadDataSource({
                loading: that.loading,
                url: "/product/create",
                dataRef: function () {
                    return that.$data;
                },
                successCallback: function (response) {
                    if (!that.$helper.validResponse(that.$router, response.data)) {
                        that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
                        that.$helper.setupErrorModel(response.data.data, that.$data);
                    } else {
                        that.showSuccessMsg({
                            message: "Tạo mới sản phẩm thành công"
                        });
                        that.$router.go(-1);
                    }
                },
                errorCallback: function (error) {
                    that.$helper.handleError(that.$router, error);
                }
            });
        },
        selectFile() {
            let that = this;
            let reader = new FileReader();
            var file = this.$refs.file.files[0];
            if (file) {
                that.fileName = file.name;
                reader.readAsDataURL(file);
                reader.onload = function () {
                    // setTimeout(function () {
                    that.imgUrl = reader.result;

                    that.selectedFiles.data.model.fileName = file.name;
                    that.selectedFiles.data.model.content = reader.result.split(',')[1];
                    that.selectedFiles.data.model.type = file.type;
                    // }, 500)
                }
            }
        },
        chooseFile() {
            this.$refs.file.click();
        }
    },
    computed: {},
    created() {
    },
    mounted() {
    },
    watch: {
    }
};
</script>